module.exports = __webpack_public_path__ + "img/marker-truck-black.7728e0f1.svg";